'use strict';
const DEFAULT_MAX_SIZE = 1000;
module.exports = function GoldFileChangesCache(maxSize) {
	const self = this,
		changeIdentifiers = [],
		calculateEnvelopeId = (envelope) => {
			return envelope && envelope.header && envelope.header.sessionId && envelope.header.sequence && `${envelope.header.sessionId}/${envelope.header.sequence}`;
		},
		toChangeIdentifier = (change) => {
			if (!change || !change.header || !change.header.sessionId || change.header.sequence === undefined) {
				return false;
			}
			return [change.header.sessionId, change.header.sequence].join(':');
		},
		sentButNotReceived = {};
	maxSize = maxSize || DEFAULT_MAX_SIZE;
	self.store = (change) => {
		const changeIdentifier = toChangeIdentifier(change);
		if (changeIdentifier) {
			changeIdentifiers.unshift(changeIdentifier);
			if (changeIdentifiers.length > maxSize) {
				changeIdentifiers.pop();
			}
		}
	};
	self.exists = (change) => {
		const changeIdentifier = toChangeIdentifier(change);
		return changeIdentifier && changeIdentifiers.includes(changeIdentifier);
	};
	self.sent = (envelope) => {
		const envelopeId = calculateEnvelopeId(envelope);
		if (envelopeId) {
			sentButNotReceived[envelopeId] = {
				ts: Date.now(),
				envelope: envelope
			};
		}
	};
	self.received = (envelopes) => {
		envelopes.forEach(envelope => {
			const envelopeId = calculateEnvelopeId(envelope);
			delete sentButNotReceived[envelopeId];
		});
	};
	self.envelopesPendingReciept = (millis) => {
		const now = Date.now();
		return Object.values(sentButNotReceived).filter(sentRecord => {
			const sentTs = sentRecord.ts;
			return (sentTs + millis < now);
		}).map(sentRecord => sentRecord.envelope);
	};
	self.hasEnvelopesPendingReciept = (millis) => {
		const now = Date.now(),
			older = Object.values(sentButNotReceived).find(sentRecord => {
				const sentTs = sentRecord.ts;
				return (sentTs + millis < now);
			});
		return !!older;
	};
	self.millisMaxPendingReceipt = () => {
		const now = Date.now();
		return Object.keys(sentButNotReceived)
		.reduce((accumulator, key) => {
			const sentRecord = sentButNotReceived[key],
				ts = ((sentRecord && sentRecord.ts) || 0),
				age = now - ts;
			return Math.max(age, accumulator);
		}, 0);
	};
};
